import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import NoResults from '~shared/ui/NoResults';
import NotLoggedIn from '~shared/components/not-logged-in/NotLoggedIn';
import { useFixtureId } from '~SpectateStore/hooks/eventsHooks';
import { useIsUserLoggedIn } from '~SpectateStore/hooks/userHooks';
import BetGeniusStreaming from './BetGeniusStreaming';
import { getWidgetLoaderScript } from './utils';

const FeedStreaming = ({ eventId }) => {
    const isUserLoggedIn = useIsUserLoggedIn();
    const fixtureId = useFixtureId(eventId);
    const [widgetLoaderScript, setWidgetLoaderScript] = useState(null);
    const [isError, setIsError] = useState(false);
    const [ t ] = useTranslation();

    useEffect(() => {
        if (isUserLoggedIn && !widgetLoaderScript) {
            getWidgetLoaderScript(fixtureId)
                .then(setWidgetLoaderScript)
                .catch((error) => {
                    console.error(error); //eslint-disable-line
                    setIsError(true);
                });
        }
    }, [isUserLoggedIn]);

    if (!isUserLoggedIn) {
        return <NotLoggedIn />;
    }

    if (isError) {
        return (
            <NoResults>
                {t('streaming.not_available')}
            </NoResults>
        );
    }

    return (
        <BetGeniusStreaming
            eventId={eventId}
            widgetLoaderScript={widgetLoaderScript}
            updateStatus={(isError) => setIsError(isError)}
        />
    );
};

FeedStreaming.propTypes = {
    eventId: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.number.isRequired,
    ]),
};

export default FeedStreaming;
